import { render, staticRenderFns } from "./CheckmarkIcon.vue?vue&type=template&id=04608042"
import script from "./CheckmarkIcon.vue?vue&type=script&lang=js"
export * from "./CheckmarkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports